/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ successful: NonNullable<unknown>, total: NonNullable<unknown>, suffix: NonNullable<unknown>, failed: NonNullable<unknown> }} Orders_Bulk_Update_PartialInputs */

const en_orders_bulk_update_partial = /** @type {(inputs: Orders_Bulk_Update_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.successful}/${i?.total} orders${i?.suffix}. ${i?.failed} failed.`)
};

const es_orders_bulk_update_partial = /** @type {(inputs: Orders_Bulk_Update_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se actualizaron ${i?.successful}/${i?.total} pedidos${i?.suffix}. Fallaron ${i?.failed}.`)
};

/**
* | output |
* | --- |
* | "Updated {successful}/{total} orders{suffix}. {failed} failed." |
*
* @param {Orders_Bulk_Update_PartialInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_bulk_update_partial = /** @type {((inputs: Orders_Bulk_Update_PartialInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Bulk_Update_PartialInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_bulk_update_partial(inputs)
	return es_orders_bulk_update_partial(inputs)
});